import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Kulturminne extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleKulturminne = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var kulturminne = this.props.kulturminne
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleKulturminne}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{kulturminne.kulturminneArt}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('lokalitetsnummer')}</div>
                            <div className="value">{kulturminne.lokalitetsnummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kulturminneart')}</div>
                            <div className="value">{kulturminne.kulturminneArt}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('vernetype')}</div>
                            <div className="value">{kulturminne.vernetype}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kategori')}</div>
                            <div className="value">{kulturminne.kulturminneKategori}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('matrikkelforingsdato')}</div>
                            <div className="value"><Moment local>{kulturminne.matrikkelforingsdato}</Moment></div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Kulturminne)